/**
 * LoadingCard — the page-level "waiting on data" state.
 *
 * This is CLW's processing card (icon / title / sub / progress bar), lifted so
 * the Launch board and the campaign-details page wait the same way CLW does
 * instead of each showing a different bare line of text.
 *
 * The bar is indeterminate: these callers are waiting on fetches, not on an
 * orchestration pipeline, so there's no honest percentage to report.
 *
 * Must render inside a `clw` element — every colour the .clw-pc-* rules read
 * is a custom property scoped to `.clw` in CampaignLaunchWorkflow.css. The
 * wrapper below supplies it.
 */
import React from 'react';
import './CampaignLaunchWorkflow/CampaignLaunchWorkflow.css';
import './LoadingCard.css';

export default function LoadingCard({ title = 'Loading…', sub = null }) {
  return (
    <div className="clw lc-wrap">
      <div className="clw-processing-card">
        <div className="clw-pc-icon">⚙️</div>
        <div className="clw-pc-title">{title}</div>
        {sub && <div className="clw-pc-sub">{sub}</div>}
        <div className="clw-pc-prog-wrap">
          <div className="clw-pc-prog-fill lc-prog-indeterminate" />
        </div>
      </div>
    </div>
  );
}
